import { useStore } from '@nanostores/react';
import { memo, type HTMLAttributes, type ReactNode } from 'react';
import { workbenchStore } from '~/lib/stores/workbench';
import { classNames } from '~/utils/classNames';

import styles from './MessageGradient.module.scss';

interface MessageGradientProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  children?: ReactNode;
}

export const MessageGradient = memo<MessageGradientProps>(({ className, children, ...props }) => {
  const isProcessing = useStore(workbenchStore.isProcessing);

  return (
    <div className={classNames(styles.Shadow, 'h-6', className)} {...props}>
      {isProcessing && (
        <div
          data-testid="message-processing-indicator"
          className="size-full text-bolt-elements-textSecondary i-svg-spinners:3-dots-fade origin-center"
        />
      )}
    </div>
  );
});
